<template>
  <div class="formxieyi" v-if="qrCode">
    <div class="pagePopMask pFull" @click.self="handleOk"></div>
    <div class="pagePop pCenter">
      <div class="w">
        <div class="tit fnt_24 relative">{{ globalDataArray.siteTemplateLanguage.qr_code }}</div>

        <div class="cont txtCont1 scrollable" >
          <div class="text_img">
            <div class="img_box">
              <img :src="curInfoArray.qrImage">
            </div>
            <ul>
              <li>{{ globalDataArray.siteTemplateLanguage.three_days }}</li>
              <li>{{ globalDataArray.siteTemplateLanguage.group_chat }}</li>
            </ul>
          </div>
        </div>
        <div class="close" @click.self="handleOk"></div>
      </div>
    </div>
  </div>

</template>

<script>
import { message } from 'ant-design-vue'
import { getArticleDetail, getIndexInfo } from '@/api/api'
export default {
  name: 'QRCodeNew',
  props: {
    qrCode: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    qrCode: {
      immediate: true,
      handler(val) {
        this.show = val
      }
    }
  },
  methods: {

    handleOk(res) {
      // 自定义事件，把res传给父组件,发射事件
      this.$emit('update:qrCode', false)
      this.show = false
    }

  }
}
</script>
<style lang="scss" scoped>
::v-deep .text_img {
  text-align: center;
  .img_box {
    width: 40%;
    margin: 0 auto;
  }
}
::v-deep .pagePop .cont.txtCont1 {
  height: auto;
}
::v-deep .pagePop {
  width: 680px;
}

@media screen and (max-width: 768px) {
  ::v-deep .pagePop {
    width: 340px;
  }
}
</style>
